import aspectRatio from './4-Objects/aspect-ratio.js';
import animTiming from './6-Utilities/anim-timing.js';
import themes from './4-Objects/themes.js';
export default [
    // Objects
    aspectRatio(['responsive']),

    // Utilities
    animTiming(['responsive']),
    themes()
];

